import axios from "axios";
import { SessionStore } from "../../types/store/SessionStore";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/project`;

export const disableProjectManager = async (
  projectId: number,
  userId: number,
) => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const finalURL =
    BASE_URL + "/" + projectId + "/user/" + userId + "/disable-manager";

  return await axios
    .put<any>(
      finalURL,
      {},
      {
        headers: {
          "content-type": "application/json",
          "x-access-token": session?.accessToken,
        },
        timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
        signal:
          AbortSignal.timeout === undefined
            ? newAbortSignal(
                Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
              )
            : AbortSignal.timeout(
                Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
              ),
      },
    )
    .then((response) => response.data);
};
